
import React from 'react';
import DivContainerBody from '../../../../../components/DivContainerBody';
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import HeadTittle from '../../../../../components/HeadTittle';
import AddEditIngredientApp from '../Functionality/AddEditIngredientApp';
import IngredientsFields from './IngredientsFields';
import { ButtonNextStep, ButtonPrevStep } from '../../../../../components/buttons/ButtonNavigation';
import IngredientSummary from './IngredientSummary';
import DividerWithText from '../../../../../components/DividerWithText';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import { EditIcon } from '../../../../../components/buttons/IconButtons';
import {permissionObj} from '../../../../../Helpers/permission';
import {FILE_TYPE} from '../../../../../Helpers/fileType';
import {ACTION_MODEL} from '../../../../../Helpers/ActionModel';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import {SUGGESTION_MODE_OPTION} from '../../../../../components/PhotoPicker/SubComponent/Models/Models';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const AddEditIngredient = () => {

    const { t,DEV,permission,
        measurementUnitsAll, item, handleChange,
        disabled,
        emptyFields,
        activeStep, setActiveStep,
        steps,
        photoPickerFile, setPhotoPickerFile,
        id,
        handleStepChange,
        handleStepSetUp,
        handleAddEdit,
        errorCode, errorName,
        handleDeleteImage,
        handleOnBack,
        getTitle
    } = AddEditIngredientApp();

    return (<>
        <HeadTittle onBack={handleOnBack} name={getTitle()}>
            {(id && (DEV || permission?.includes(permissionObj?.WEB_INGREDIENT_UPDATE)) ) &&
                <ButtonAction
                    id='btn_aei_update_data'
                    name='update'
                    className='btn-icon-edit'
                    Icon={EditIcon}
                    onClick={() => {
                        handleAddEdit();
                    }}
                />
            }
        </HeadTittle>
        <DivContainerBody>
            {id == null ?
                <>
                    <StepperTabs id={null} disabled={false} steps={steps} activeStep={activeStep} isStepOptional={step=> step == 1}
                        setActiveStep={setActiveStep} handleStepChange={handleStepChange}
                    >
                        <StepTab index={0} activeStep={activeStep} normalHeight={true}>
                            <div className='row'>
                                <IngredientsFields
                                    item={item}
                                    measurementUnitsAll={measurementUnitsAll}
                                    disabled={disabled}
                                    emptyFields={emptyFields}
                                    handleChange={handleChange}
                                    errorCode={errorCode}
                                    errorName={errorName}
                                />
                            </div>
                            <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6'>
                                <ButtonNextStep
                                    id='btn_aei_next_ingredient'
                                    text='next'
                                    click={() => {
                                        if (handleStepSetUp()) {
                                            setActiveStep((prevStep) => prevStep + 1)
                                        }
                                    }}
                                />
                            </div>
                        </StepTab>
                        <StepTab index={1} activeStep={activeStep} normalHeight={true}>

                            <CustomPhotoPicker
                                id='fp_aei_create_photo_file'
                                photoPicker={photoPickerFile}
                                setPhotoPicker={setPhotoPickerFile}
                                actionModel={ACTION_MODEL.CREATE}
                                accept={{ ...FILE_TYPE.IMAGE }}
                                showBtnDelete={true}
                                required={true}
                                showBtnCamera={true}
                                validateFace={false}
                                classWith={'content-center-w-400px'}
                                showPreview={true}
                                typeSuggestions={SUGGESTION_MODE_OPTION.INGREDIENTS}
                                disabled={disabled}
                            />

                            <div className='d-flex justify-content-between px-0 mt-3'>
                                <ButtonPrevStep
                                    id='btn_aei_back_file'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_aei_next_file'
                                    text='next'
                                    disabled={activeStep === steps.length - 1}
                                    click={() => setActiveStep((prevStep) => prevStep + 1)}
                                />
                            </div>
                        </StepTab>
                        <StepTab index={2} activeStep={activeStep} normalHeight={true}>
                            <IngredientSummary
                                item={item}
                                photoPicker={photoPickerFile}
                            />
                            <div className='d-flex justify-content-between px-0 mb-2'>
                                <ButtonPrevStep
                                    id='btn_aei_back_summary'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_aei_enroll'
                                    text='create'
                                    click={() => {
                                        handleAddEdit();
                                    }}
                                />
                            </div>
                        </StepTab>
                    </StepperTabs>
                </>
                :
                <>
                    <div className='row'>
                        <div className='col-12 my-3'>
                            <DividerWithText title={t('photography')} />
                        </div>
                        <div className='col-12'>
                            <CustomPhotoPicker
                                id='fp_aei_update_photo_file'
                                photoPicker={photoPickerFile}
                                setPhotoPicker={setPhotoPickerFile}
                                actionModel={ACTION_MODEL.UPDATE}
                                accept={{ ...FILE_TYPE.IMAGE }}
                                showBtnDelete={true}
                                required={true}
                                disabled={disabled}
                                showBtnCamera={true}
                                validateFace={false}
                                classWith={'content-center-w-400px'}
                                showPreview={true}
                                typeSuggestions={SUGGESTION_MODE_OPTION.INGREDIENTS}
                                titleModalEdit={'update_ingredient_photograph'}
                                handleDelete={ photoPickerFile?.previewImage != null ? () => handleDeleteImage() : undefined}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12 my-3'>
                            <DividerWithText title={t('details')} />
                        </div>
                    </div>
                    <div className='row'>
                        <IngredientsFields
                            item={item}
                            measurementUnitsAll={measurementUnitsAll}
                            disabled={disabled}
                            emptyFields={emptyFields}
                            handleChange={handleChange}
                            errorCode={errorCode}
                            errorName={errorName}
                        />
                    </div>
                </>
            }
        </DivContainerBody>
    </>)
}

export default AddEditIngredient;
